function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module ui/labeledfield/labeledfieldview
 */
import View from '../view';
import uid from '@ckeditor/ckeditor5-utils/src/uid';
import LabelView from '../label/labelview';
import '../../theme/components/labeledfield/labeledfieldview.css';
/**
 * The labeled field view class. It can be used to enhance any view with the following features:
 *
 * * a label,
 * * (optional) an error message,
 * * (optional) an info (status) text,
 *
 * all bound logically by proper DOM attributes for UX and accessibility.  It also provides an interface
 * (e.g. observable properties) that allows controlling those additional features.
 *
 * The constructor of this class requires a callback that returns a view to be labeled. The callback
 * is called with unique ids that allow binding of DOM properties:
 *
 *		const labeledInputView = new LabeledFieldView( locale, ( labeledFieldView, viewUid, statusUid ) => {
 *			const inputView = new InputTextView( labeledFieldView.locale );
 *
 *			inputView.set( {
 *				id: viewUid,
 *				ariaDescribedById: statusUid
 *			} );
 *
 *			inputView.bind( 'isReadOnly' ).to( labeledFieldView, 'isEnabled', value => !value );
 *			inputView.bind( 'hasError' ).to( labeledFieldView, 'errorText', value => !!value );
 *
 *			return inputView;
 *		} );
 *
 *		labeledInputView.label = 'User name';
 *		labeledInputView.infoText = 'Full name like for instance, John Doe.';
 *		labeledInputView.render();
 *
 *		document.body.append( labeledInputView.element );
 *
 * See {@link module:ui/labeledfield/utils} to discover ready–to–use labeled input helpers for common
 * UI components.
 *
 * @extends module:ui/view~View
 */

var LabeledFieldView = /*#__PURE__*/function (_View) {
  _inherits(LabeledFieldView, _View);

  var _super = _createSuper(LabeledFieldView);

  /**
   * Creates an instance of the labeled field view class using a provided creator function
   * that provides the view to be labeled.
   *
   * @param {module:utils/locale~Locale} locale The locale instance.
   * @param {Function} viewCreator A function that returns a {@link module:ui/view~View}
   * that will be labeled. The following arguments are passed to the creator function:
   *
   * * an instance of the `LabeledFieldView` to allow binding observable properties,
   * * an UID string that connects the {@link #labelView label} and the labeled field view in DOM,
   * * an UID string that connects the {@link #statusView status} and the labeled field view in DOM.
   */
  function LabeledFieldView(locale, viewCreator) {
    var _this;

    _classCallCheck(this, LabeledFieldView);

    _this = _super.call(this, locale);
    var viewUid = "ck-labeled-field-view-".concat(uid());
    var statusUid = "ck-labeled-field-view-status-".concat(uid());
    /**
     * The field view that gets labeled.
     *
     * @member {module:ui/view~View} #fieldView
     */

    _this.fieldView = viewCreator(_assertThisInitialized(_this), viewUid, statusUid);
    /**
     * The text of the label.
     *
     * @observable
     * @member {String} #label
     */

    _this.set('label');
    /**
     * Controls whether the component is in read-only mode.
     *
     * @observable
     * @member {Boolean} #isEnabled
     */


    _this.set('isEnabled', true);
    /**
     * An observable flag set to `true` when {@link #fieldView} is empty (`false` otherwise).
     *
     * @readonly
     * @observable
     * @member {Boolean} #isEmpty
     * @default true
     */


    _this.set('isEmpty', true);
    /**
     * An observable flag set to `true` when {@link #fieldView} is currently focused by
     * the user (`false` otherwise).
     *
     * @readonly
     * @observable
     * @member {Boolean} #isFocused
     * @default false
     */


    _this.set('isFocused', false);
    /**
     * The validation error text. When set, it will be displayed
     * next to the {@link #fieldView} as a typical validation error message.
     * Set it to `null` to hide the message.
     *
     * **Note:** Setting this property to anything but `null` will automatically
     * make the `hasError` of the {@link #fieldView} `true`.
     *
     * @observable
     * @member {String|null} #errorText
     */


    _this.set('errorText', null);
    /**
     * The additional information text displayed next to the {@link #fieldView} which can
     * be used to inform the user about its purpose, provide help or hints.
     *
     * Set it to `null` to hide the message.
     *
     * **Note:** This text will be displayed in the same place as {@link #errorText} but the
     * latter always takes precedence: if the {@link #errorText} is set, it replaces
     * {@link #infoText}.
     *
     * @observable
     * @member {String|null} #infoText
     * @default null
     */


    _this.set('infoText', null);
    /**
     * (Optional) The additional CSS class set on the dropdown {@link #element}.
     *
     * @observable
     * @member {String} #class
     */


    _this.set('class');
    /**
     * The content of the `placeholder` attribute of the {@link #fieldView}.
     *
     * @observable
     * @member {String} #placeholder
     */


    _this.set('placeholder');
    /**
     * The label view instance that describes the entire view.
     *
     * @member {module:ui/label/labelview~LabelView} #labelView
     */


    _this.labelView = _this._createLabelView(viewUid);
    /**
     * The status view for the {@link #fieldView}. It displays {@link #errorText} and
     * {@link #infoText}.
     *
     * @member {module:ui/view~View} #statusView
     */

    _this.statusView = _this._createStatusView(statusUid);
    /**
     * The combined status text made of {@link #errorText} and {@link #infoText}.
     * Note that when present, {@link #errorText} always takes precedence in the
     * status.
     *
     * @see #errorText
     * @see #infoText
     * @see #statusView
     * @private
     * @observable
     * @member {String|null} #_statusText
     */

    _this.bind('_statusText').to(_assertThisInitialized(_this), 'errorText', _assertThisInitialized(_this), 'infoText', function (errorText, infoText) {
      return errorText || infoText;
    });

    var bind = _this.bindTemplate;

    _this.setTemplate({
      tag: 'div',
      attributes: {
        class: ['ck', 'ck-labeled-field-view', bind.to('class'), bind.if('isEnabled', 'ck-disabled', function (value) {
          return !value;
        }), bind.if('isEmpty', 'ck-labeled-field-view_empty'), bind.if('isFocused', 'ck-labeled-field-view_focused'), bind.if('placeholder', 'ck-labeled-field-view_placeholder'), bind.if('errorText', 'ck-error')]
      },
      children: [{
        tag: 'div',
        attributes: {
          class: ['ck', 'ck-labeled-field-view__input-wrapper']
        },
        children: [_this.fieldView, _this.labelView]
      }, _this.statusView]
    });

    return _this;
  }
  /**
   * Creates label view class instance and bind with view.
   *
   * @private
   * @param {String} id Unique id to set as labelView#for attribute.
   * @returns {module:ui/label/labelview~LabelView}
   */


  _createClass(LabeledFieldView, [{
    key: "_createLabelView",
    value: function _createLabelView(id) {
      var labelView = new LabelView(this.locale);
      labelView.for = id;
      labelView.bind('text').to(this, 'label');
      return labelView;
    }
    /**
     * Creates the status view instance. It displays {@link #errorText} and {@link #infoText}
     * next to the {@link #fieldView}. See {@link #_statusText}.
     *
     * @private
     * @param {String} statusUid Unique id of the status, shared with the {@link #fieldView view's}
     * `aria-describedby` attribute.
     * @returns {module:ui/view~View}
     */

  }, {
    key: "_createStatusView",
    value: function _createStatusView(statusUid) {
      var statusView = new View(this.locale);
      var bind = this.bindTemplate;
      statusView.setTemplate({
        tag: 'div',
        attributes: {
          class: ['ck', 'ck-labeled-field-view__status', bind.if('errorText', 'ck-labeled-field-view__status_error'), bind.if('_statusText', 'ck-hidden', function (value) {
            return !value;
          })],
          id: statusUid,
          role: bind.if('errorText', 'alert')
        },
        children: [{
          text: bind.to('_statusText')
        }]
      });
      return statusView;
    }
    /**
     * Focuses the {@link #fieldView}.
     */

  }, {
    key: "focus",
    value: function focus() {
      this.fieldView.focus();
    }
  }]);

  return LabeledFieldView;
}(View);

export { LabeledFieldView as default };